import { defineMessages } from 'react-intl';

export const messages: {
	emptyStateDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requestFormsHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	resourcesHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamPortalsHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	emptyStateTitle: {
		id: 'company-hub.help-object-search-component.empty-title',
		defaultMessage: "We couldn't find a match for your search",
		description: 'Text displayed in the dialog when no results are found during the search.',
	},
	emptyStateDescription: {
		id: 'company-hub.help-object-search-component.empty-description',
		defaultMessage: 'Check for typos, or try another search term.',
		description: 'Text displayed in the search dialog to guide users when there are no results.',
	},
	errorTitle: {
		id: 'company-hub.help-object-search-component.error-title',
		defaultMessage: "We're having trouble getting your results.",
		description: 'Text displayed in the dialog when an error occurs during the search.',
	},
	errorDescription: {
		id: 'company-hub.help-object-search-component.error-description',
		defaultMessage: 'Try again later',
		description: 'Text displayed in the search dialog to guide users when there is an error.',
	},
	resourcesHeading: {
		id: 'company-hub.help-object-search-component.resources-heading',
		defaultMessage: 'Resources',
		description: 'Heading for the resources section in search results.',
	},
	teamPortalsHeading: {
		id: 'company-hub.help-object-search-component.team-portals-heading',
		defaultMessage: 'Team Portals',
		description: 'Heading for the team portals section in search results.',
	},
	requestFormsHeading: {
		id: 'company-hub.help-object-search-component.request-forms-heading',
		defaultMessage: 'Request forms',
		description: 'Heading for the request forms section in search results.',
	},
});
